'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faArrowDown,
  faArrowUp,
  faArrowLeft,
  faArrowRight,
  faArrowUpRightFromSquare,
  faAward,
  faBaby,
  faBagShopping,
  faBars,
  faBed,
  faBuildingColumns,
  faCalendarDay,
  faCar,
  faCartShopping,
  faLayerGroup,
  faMoneyBillTransfer,
  faCheck,
  faChevronDown,
  faChevronRight,
  faCircle,
  faCircleCheck,
  faCircleDot,
  faCircleExclamation,
  faCircleInfo,
  faCircleUser,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faComment,
  faCreditCard,
  faDumbbell,
  faEarthEurope,
  faEnvelope,
  faEnvelopeCircleCheck,
  faEuroSign,
  faExpand,
  faEye,
  faFileLines,
  faFlag,
  faFloppyDisk,
  faFutbol,
  faGlobe,
  faGraduationCap,
  faHand,
  faHospital,
  faHourglassStart,
  faHouse,
  faIdBadge,
  faLandmark,
  faLocationCrosshairs,
  faLocationDot,
  faMagnifyingGlass,
  faMap,
  faMapPin,
  faMountain,
  faMugHot,
  faPaperPlane,
  faPen,
  faPills,
  faPhone,
  faPlane,
  faPlus,
  faReceipt,
  faRightFromBracket,
  faRightToBracket,
  faRotate,
  faRoute,
  faRuler,
  faShield,
  faStar,
  faSuitcase,
  faTag,
  faToggleOff,
  faToggleOn,
  faTaxi,
  faTicket,
  faTrash,
  faTrashCan,
  faTrain,
  faTree,
  faTriangleExclamation,
  faUser,
  faUserPlus,
  faUsers,
  faUtensils,
  faXmark,
  faQuoteRight,
  faUserMinus,
  faLanguage,
  faIdCard,
  faCity,
  faPaw,
  faCalendarDays,
  faSpinner,
  faFileImage,
  faImage,
  faHashtag,
  faUpload,
  faPaperclip,
  faBuilding,
  faAddressCard,
  faBan,
  faPenToSquare,
  faUsersSlash,
  faLock,
  faLinkSlash,
  faList,
  faArrowRotateRight,
  faFileCircleXmark,
  faBell,
  faHeadset,
  faArrowsSpin,
  faDownload,
  faUserGear,
  faCalendar,
  faPlay,
  faFilter,
  faFilterCircleXmark,
  faStopwatch,
  faGift,
} from '@fortawesome/free-solid-svg-icons'
import { faStar as faStarRegular } from '@fortawesome/free-regular-svg-icons'
import type { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'

const iconMap: Record<string, IconDefinition> = {
  // Navigation & actions
  add: faPlus,
  arrow_back: faArrowLeft,
  arrow_forward: faArrowRight,
  arrow_downward: faArrowDown,
  arrow_upward: faArrowUp,
  cancel: faCircleXmark,
  check: faCheck,
  check_circle: faCircleCheck,
  chevron_right: faChevronRight,
  close: faXmark,
  delete: faTrash,
  delete_forever: faTrashCan,
  edit: faPen,
  error: faCircleExclamation,
  expand_more: faChevronDown,
  login: faRightToBracket,
  logout: faRightFromBracket,
  menu: faBars,
  open_in_full: faExpand,
  open_in_new: faArrowUpRightFromSquare,
  save: faFloppyDisk,
  search: faMagnifyingGlass,
  send: faPaperPlane,
  sync: faRotate,
  visibility: faEye,
  format_quote: faQuoteRight,
  document_scanner: faFileImage,
  nest_clock_farsight_analog: faClock,
  image: faImage,
  '123': faHashtag,
  upload: faUpload,
  upload_file: faUpload,
  attach_file: faPaperclip,
  download: faDownload,
  business: faBuilding,
  corporate_fare: faBuilding,
  contact_mail: faAddressCard,
  no_transfer: faBan,
  checked_bag: faSuitcase,
  add_notes: faPenToSquare,
  sell: faTag,
  label: faTag,
  category: faLayerGroup,
  workspace_premium: faAward,
  toggle_on: faToggleOn,
  toggle_off: faToggleOff,
  manage_accounts: faUserGear,
  play_arrow: faPlay,
  filter_alt: faFilter,
  filter_alt_off: faFilterCircleXmark,

  // Location & transport
  pin_drop: faMapPin,
  trip_origin: faCircleDot,
  add_location: faMapPin,
  add_location_alt: faMapPin,
  directions_car: faCar,
  fiber_manual_record: faCircle,
  flag: faFlag,
  flight: faPlane,
  hail: faHand,
  home_pin: faHouse,
  local_taxi: faTaxi,
  location_on: faLocationDot,
  map: faMap,
  my_location: faLocationCrosshairs,
  place: faMapPin,
  route: faRoute,
  train: faTrain,
  travel_explore: faEarthEurope,
  circle: faCircle,
  lock: faLock,
  link_off: faLinkSlash,
  refresh: faArrowRotateRight,
  event_repeat: faArrowsSpin,

  // People
  account_circle: faCircleUser,
  badge: faIdBadge,
  groups: faUsers,
  group_off: faUsersSlash,
  person: faUser,
  person_add: faUserPlus,
  person_remove: faUserMinus,
  abc: faLanguage,
  id_card: faIdCard,
  file_copy_off: faFileCircleXmark,

  // Time & status
  calendar_today: faCalendarDay,
  calendar_month: faCalendar,
  history: faClockRotateLeft,
  hourglass_top: faHourglassStart,
  timer: faStopwatch,
  info: faCircleInfo,
  location_off: faMapPin,
  schedule: faClock,
  star: faStar,
  straighten: faRuler,
  warning: faTriangleExclamation,
  wifi_off: faTriangleExclamation,
  progress_activity: faSpinner,

  // Communication
  call: faPhone,
  chat: faComment,
  chat_bubble: faComment,
  description: faFileLines,
  mail: faEnvelope,
  mark_email_read: faEnvelopeCircleCheck,
  mark_email_unread: faEnvelope,
  notifications: faBell,
  support: faHeadset,
  phone: faPhone,
  list: faList,

  // Finance & commerce
  payments: faCreditCard,
  receipt_long: faReceipt,
  shopping_bag: faBagShopping,
  shopping_cart_checkout: faCartShopping,
  attach_money: faEuroSign,
  euro: faEuroSign,
  currency_exchange: faMoneyBillTransfer,
  redeem: faGift,

  // Places & activities
  account_balance: faLandmark,
  attractions: faTicket,
  child_care: faBaby,
  hotel: faBed,
  landscape: faMountain,
  language: faGlobe,
  local_cafe: faMugHot,
  local_hospital: faHospital,
  local_pharmacy: faPills,
  luggage: faSuitcase,
  museum: faBuildingColumns,
  park: faTree,
  restaurant: faUtensils,
  school: faGraduationCap,
  shield: faShield,
  sports: faDumbbell,
  stadium: faFutbol,
  location_city: faCity,
  pets: faPaw,
  event: faCalendarDays,
}

interface IconProps {
  name: string
  className?: string
  filled?: boolean
}

const Icon = ({ name, className, filled = true }: IconProps) => {
  if (name === 'star') {
    return (
      <FontAwesomeIcon icon={(filled ? faStar : faStarRegular) as IconProp} className={className} />
    )
  }

  const icon = iconMap[name]

  if (!icon) {
    // Le registre est explicite : un nom absent ne rend rien, et l'icone
    // disparait sans bruit de l'interface. On le signale en developpement
    // plutot que de le decouvrir a l'ecran.
    if (process.env.NODE_ENV !== 'production') {
      console.warn(`Icon: nom inconnu « ${name} », aucune icone rendue.`)
    }

    return null
  }

  return <FontAwesomeIcon icon={icon} className={className} />
}

export default Icon
